import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { setToken, clearToken } from '../lib/authToken';

const AuthContext = createContext(null);
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001'; // fallback dev only

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await axios.get(`${BACKEND_URL}/api/auth/me`, { withCredentials: true });
        setUser(res.data);
      } catch (err) {
        setUser(null);
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, []);

  const login = async (email, password) => {
    const res = await axios.post(`${BACKEND_URL}/api/auth/login`, { email, password }, { withCredentials: true });
    if (res.data.token) setToken(res.data.token);
    setUser(res.data.user);
    return res.data;
  };

  const register = async (email, password, name, role) => {
    const res = await axios.post(`${BACKEND_URL}/api/auth/register`, { email, password, name, role }, { withCredentials: true });
    if (res.data.token) setToken(res.data.token);
    setUser(res.data.user);
    return res.data;
  };

  const logout = async () => {
    try {
      await axios.post(`${BACKEND_URL}/api/auth/logout`, {}, { withCredentials: true });
    } catch(e) {}
    clearToken();
    setUser(null);
  };

  // Recarga el usuario desde el backend (tras guardar el perfil, etc.) para que
  // los datos actualizados se reflejen al instante en toda la app.
  const refreshUser = async () => {
    try {
      const res = await axios.get(`${BACKEND_URL}/api/auth/me`, { withCredentials: true });
      setUser(res.data);
      return res.data;
    } catch { return null; }
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, loading, refreshUser }}>
        {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
